import { Component, OnInit } from '@angular/core';
import { FullHeaderSliderComponent } from '../../../../layout/components/full-header-slider/full-header-slider.component';


@Component({
  selector: 'news-archive-header',
  templateUrl: './news-archive-header.component.html',
  styleUrls: ['./news-archive-header.component.scss'],
  standalone:true,
  imports:[FullHeaderSliderComponent]
})
export class NewsArchiveHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
